module.exports = __webpack_public_path__ + "img/eduac-logo.c7c96515.png";